import { Component } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { FormLoading } from '../../forms/base-form/base-form.component';

@Component({
  selector: 'app-landing-settings-modal',
  templateUrl: './landing-settings-modal.component.html',
  styleUrls: ['./landing-settings-modal.component.scss'],
})
export class LandingSettingsModalComponent extends BaseModalComponent {
  public handleSubmit({ values, formLoading }: { values: any; formLoading: FormLoading }) {
    try {
      this.startLoading();
      formLoading.start();

      // TODO: add logic

      formLoading.stop();
      this.stopLoading();
      this.close(values);
    } catch (err) {
      formLoading.stop();
      this.stopLoading();
    }
  }
}
